<template>
  <div class="login-body">
    <div class="col-12 center-login">
      <div class="modal-dialog">
        <div
          v-if="!showSignupModal && !showResetPasswordModal"
          id="login-content"
          class="modal-content itenter-pop"
          :class="{'shake': isErrorShake}"
        >
          <div class="login-modal text-center">
            <h4 class="modal-title">Մուքագրեք նոր գաղտնաբառը</h4>
          </div>
          <div class="modal-body pt-2">
            <form>
              <span 
                v-if="errorMsgFromApi" 
                class="mb-3 d-block w-100 text-center text-danger" 
              >
                  Հղման ժամկետը լրացել է 
              </span>
              <div class="form-row">
                <div class="col-md-12 mb-3 px-md-3">
                  <float-label :dispatch="false">
                    <input
                      id="password"
                      v-model="$v.fields.password.$model"
                      type="password"
                      :placeholder="$t('state_customer.pl_password')"
                      class="auth-input form-control"
                      :class="{'border-danger': isInvalidField('password', 'required') || isInvalidField('password', 'minLength')}"
                      name="password"
                    />
                  </float-label>
                  <div v-if="isInvalidField('password', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
                  <div v-if="isInvalidField('password', 'minLength')" class="small text-danger"> {{ $t('state_customer.valid_4') }}</div>
                </div>
                <div class="col-md-12 mb-3 px-md-3">
                  <float-label :dispatch="false">
                    <input
                      id="repeat-password"
                      v-model="$v.fields.password_confirmation.$model"
                      type="password"
                      :placeholder="$t('state_customer.repeat_pl_password')"
                      class="auth-input form-control"
                      :class="{'border-danger': isInvalidField('password_confirmation', 'required') || isInvalidField('password_confirmation', 'sameAsPassword')}"
                      name="repeat-password"
                    />
                  </float-label>
                  <div v-if="isInvalidField('password_confirmation', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
                  <div v-if="isInvalidField('password_confirmation', 'sameAsPassword')" class="small text-danger">{{ $t('state_customer.valid_5') }}</div>
                </div>
              </div>
              <div class="row justify-content-center">
                  <a 
                    @click.prevent="confirm"
                    class="btn btn-primary text-light text-center"
                  >
                    Հաստատել
                  </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import '@/assets/styles/main.scss';
</style>

<script>
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
export default {
  name: 'ResetPassword',
  components: {  },
  data () {
    return {
      showSignupModal: false,
      showResetPasswordModal: false,
      fields: {
        password: '',
        password_confirmation: ''
      },
      rememberMe: true,
      errorMsgFromApi: '',
      isLoginPending: false,
      isErrorShake: false,
    }
  },
  computed: {
    passwordRequired () {
      return this.$v.fields.password.$dirty && !this.$v.fields.password.required
    }
  },
  methods: {
    isInvalidField (pathToField, validator) {
      const keyArr = pathToField.split('.')
      const field = keyArr.reduce((acc, key) => {
        return acc[key]
      }, this.$v.fields)
      return validator === 'required' ?
        field.$dirty && !field.required :
        field.required && !field[validator]
    },
    confirm () {
      this.$v.fields.$touch()
      if (!this.$v.fields.$invalid) {
        this.isLoginPending = true
        this.$client.post(`forgot/password`, {
          token: this.$route.params.token, ...this.fields
        }) .then(({data}) => {
          this.isLoginPending = false
          if (data.status) {
            this.$router.push({ path: '/login' })
          }
        }).catch(({data}) => {
          this.errorMsgFromApi = data.message
        })
        // this.$store.dispatch('auth', {
        //   url: 'login',
        //   fields: this.fields,
        //   rememberMe: this.rememberMe
        // })
        // .then(response => {
        //   this.isLoginPending = false
        //   if (response.message === "Login Failed") {
        //     console.log(response)
        //     this.isErrorShake = true
        //     setTimeout(() => {
        //       this.isErrorShake = false
        //     }, 700)
        //     this.errorMsgFromApi = response.message
        //   } else {
        //     this.$router.push({ path: '/dashboard' })
        //   }
        // })
      }
    }
  },
  validations: {
    fields: {
      password: { required, minLength: minLength(6) },
      password_confirmation: { required, sameAsPassword: sameAs('password') },
    }
  }
}
</script>

<style scoped>
  .shake {
    animation: shake 0.7s cubic-bezier(.36,.07,.19,.97) both;
    transform: translate3d(0, 0, 0);
  }
  @keyframes shake {
    10%, 90% {
      transform: translate3d(-1px, 0, 0);
    }
    20%, 80% {
      transform: translate3d(2px, 0, 0);
    }
    30%, 50%, 70% {
      transform: translate3d(-4px, 0, 0);
    }
    40%, 60% {
      transform: translate3d(4px, 0, 0);
    }
}
</style>
